"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeList = void 0;
const Flag_1 = require("@opsbase/lib-issue/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Chip_1 = __importDefault(require("@opsbase/web-chips/Chip"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useAltForSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useAltForSysLang"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importStar(require("react"));
const react_sortablejs_1 = require("react-sortablejs");
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const useFedExpand_1 = __importDefault(require("../FedController/useFedExpand"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const QuestionTreeNode_1 = __importDefault(require("./QuestionTreeNode"));
const QuestionTreeNodePlaceholder_1 = __importDefault(require("./QuestionTreeNodePlaceholder"));
const PLACEHOLDER = 'placeholder';
const makeMyClasses = () => ({
    root: {
        position: 'relative',
        '& .questionTreeGhost': {
            '& .selectionContainer': {
                border: `2px solid ${lib_palette_1.default.secondary.main}`,
                backgroundColor: lib_palette_1.default.LightBlue.main,
            },
            '& .hideInGhost': {
                display: 'none',
            },
        },
        '& .questionTreeDrag': {
            '& .hideInDrag': {
                display: 'none',
            },
        },
    },
    condition: {
        position: 'absolute',
        zIndex: 3,
        width: 52,
        left: -48,
        top: 16,
        fontSize: 10,
    },
});
function mapQIds(db, listId) {
    var _a;
    return (_a = db.lists[listId].childQIds) === null || _a === void 0 ? void 0 : _a.map(id => ({ id }));
}
exports.QuestionTreeList = react_1.default.memo((props) => {
    const { listId, disabled = false } = props;
    const { expands } = (0, useFedExpand_1.default)();
    const db = (0, useFedDB_1.default)();
    const { showDragPlaceholders } = (0, useFedSetup_1.default)();
    const { doDragStart, doDragEnd, canDrop } = (0, useFedActions_1.default)();
    const [qIds, setQIds] = (0, react_1.useState)(mapQIds(db, listId));
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const list = db.lists[listId];
    const isExpanded = !list.parentQId || !!expands[list.parentQId];
    const hasQuestions = !!(qIds === null || qIds === void 0 ? void 0 : qIds.length);
    const [label] = (0, useAltForSysLang_1.default)(list.label, list.labelAlt);
    (0, react_1.useEffect)(() => {
        setQIds(mapQIds(db, listId));
    }, [db, listId]);
    const handleSetQuestions = (0, react_1.useCallback)(newQuestions => {
        if (hasQuestions)
            setQIds(newQuestions);
    }, [hasQuestions]);
    const handleDragStart = (0, react_1.useCallback)(e => doDragStart(qIds[e.oldIndex].id), [qIds, doDragStart]);
    const handleDragEnd = (0, react_1.useCallback)(e => doDragEnd(e.to.id, e.newIndex), [doDragEnd]);
    const handleDragMove = (0, react_1.useCallback)(e => {
        var _a, _b, _c;
        if ((_b = (_a = e === null || e === void 0 ? void 0 : e.to) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.startsWith('qsetId_'))
            return false;
        if (((_c = e === null || e === void 0 ? void 0 : e.related) === null || _c === void 0 ? void 0 : _c.className.indexOf('noDnD')) >= 0 && (e === null || e === void 0 ? void 0 : e.willInsertAfter))
            return false;
        return canDrop(e.to.id, e.newIndex);
    }, [canDrop]);
    return (0, react_1.useMemo)(() => {
        if (!isExpanded)
            return null;
        const isRoot = listId === 'root';
        const hasEmptyQuestion = !!(qIds === null || qIds === void 0 ? void 0 : qIds.find(q => { var _a; return q.id !== PLACEHOLDER && !((_a = db.questions[q.id]) === null || _a === void 0 ? void 0 : _a.title); }));
        const showPlaceHolder = showDragPlaceholders && !disabled && !hasEmptyQuestion && !isRoot;
        const data = !showPlaceHolder ? qIds : [...qIds, { id: PLACEHOLDER }];
        if (!hasQuestions && isRoot)
            return;
        const treeNodes = qIds === null || qIds === void 0 ? void 0 : qIds.map(({ id }) => (react_1.default.createElement(QuestionTreeNode_1.default, { key: 'FormTreeNode' + id, questionId: id })));
        const sortables = !showPlaceHolder
            ? treeNodes
            : [...treeNodes, react_1.default.createElement(QuestionTreeNodePlaceholder_1.default, { key: "FormTreePlaceholder" })];
        return (react_1.default.createElement(Pane_1.default, { visible: true, classes: { root: myCss.root } },
            label && (react_1.default.createElement(Chip_1.default, { classes: { root: myCss.condition }, label: label, color: (0, Flag_1.flagColor)(list.flag), fullWidth: true })),
            react_1.default.createElement(react_sortablejs_1.ReactSortable, { id: list.lid, group: disabled ? 'DISABLED' : 'formtree', handle: ".dragHandle", animation: 100, easing: "cubic-bezier(1, 0, 0, 1)", ghostClass: 'questionTreeGhost', filter: '.noDnD', dragClass: 'questionTreeDrag', list: data, setList: handleSetQuestions, onStart: handleDragStart, onMove: handleDragMove, onEnd: handleDragEnd }, sortables)));
    }, [
        isExpanded,
        listId,
        qIds,
        showDragPlaceholders,
        disabled,
        hasQuestions,
        myCss.root,
        myCss.condition,
        label,
        list.flag,
        list.lid,
        handleSetQuestions,
        handleDragStart,
        handleDragMove,
        handleDragEnd,
        db.questions,
    ]);
});
exports.default = exports.QuestionTreeList;
